var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-container"},[_c('div',{staticClass:"items"},[_c('a',{attrs:{"href":"mailto:mohammadporteghali@gmail.comh"}},[_vm._v("Email")]),_c('a',{attrs:{"href":"http://linkedin.com/in/mohammad-porteghali-b66926176"}},[_vm._v("LinkedIn")]),_c('a',{attrs:{"href":"https://github.com/MohammadPorteghali"}},[_vm._v("Github")])])])
}]

export { render, staticRenderFns }